import * as React from 'react';

import * as styles from './GeoBlock.css';

export const GeoBlock = ({ children }: React.PropsWithChildren) => {
  return (
    <div data-testid="geo" className={styles['container']}>
      {children}
    </div>
  );
};
